import {getBookInfoAction} from "./actions";

export default (state={} , action) => {
    switch (action.type) {
        case getBookInfoAction.resultAction :
            return action.payload.data.data ;
        default :
            return state ;
    }
};